import React from 'react';
import { translate } from 'react-polyglot';
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownMenuItem } from 'decap-cms-ui-next';
import { ControlButton } from './ControlButton';
import { jsx as ___EmotionJSX } from "@emotion/react";
function FilterControl({
  viewFilters,
  t,
  onFilterClick,
  filter
}) {
  const hasActiveFilter = filter === null || filter === void 0 ? void 0 : filter.valueSeq().toJS().some(f => f.active === true);
  return ___EmotionJSX(Dropdown, null, ___EmotionJSX(DropdownTrigger, null, ___EmotionJSX(ControlButton, {
    active: hasActiveFilter
  }, t('collection.collectionTop.filterBy'))), ___EmotionJSX(DropdownMenu, {
    anchorOrigin: {
      y: 'bottom',
      x: 'right'
    }
  }, viewFilters.map(viewFilter => {
    return ___EmotionJSX(DropdownMenuItem, {
      key: viewFilter.id,
      onClick: () => onFilterClick(viewFilter),
      selected: filter.getIn([viewFilter.id, 'active'], false)
    }, viewFilter.label);
  })));
}
export default translate()(FilterControl);